import React from "react";
import PropTypes from "prop-types";
import { Button, Label } from "reactstrap";

/**
 * Carga de logo con vista previa: miniatura, nombre del archivo, "Subir logo" y
 * "Borrar" opcional. Estilos globales en scss/dhn/_logo-uploader.scss.
 * La validación del archivo la hace cada módulo en `onFileChange`.
 */
export default function LogoUploader({
  inputId,
  title,
  label,
  source,
  placeholderIcon,
  accept,
  onFileChange,
  onClear,
  onPreview,
  onError,
}) {
  return (
    <div className="dhn-logo-uploader">
      <button
        type="button"
        className="dhn-logo-uploader__preview"
        disabled={!source || !onPreview}
        onClick={onPreview}
        title={source ? "Ver logo en grande" : "Sin logo cargado"}
        aria-label={source ? "Ver logo en grande" : "Sin logo cargado"}
      >
        {source ? (
          <img src={source} alt={title} onError={onError} />
        ) : (
          <div className="dhn-logo-uploader__placeholder">
            <i className={`fa ${placeholderIcon}`} aria-hidden="true"></i>
          </div>
        )}
      </button>
      <div className="dhn-logo-uploader__copy">
        <strong>{title}</strong>
        <span>{label || "Sin logo cargado"}</span>
      </div>
      <div className="dhn-logo-uploader__actions">
        <input id={inputId} type="file" accept={accept} onChange={onFileChange} />
        <Label htmlFor={inputId} className="btn btn-primary btn-color-primary mb-0">
          <i className="fa fa-upload mr-1" aria-hidden="true"></i>
          Subir logo
        </Label>
        {onClear && (
          <Button color="danger" className="btn-color-danger" type="button" onClick={onClear}>
            <i className="fa fa-trash mr-1" aria-hidden="true"></i>
            Borrar
          </Button>
        )}
      </div>
    </div>
  );
}

LogoUploader.propTypes = {
  accept: PropTypes.string,
  inputId: PropTypes.string.isRequired,
  label: PropTypes.node,
  onClear: PropTypes.func,
  onError: PropTypes.func,
  onFileChange: PropTypes.func.isRequired,
  onPreview: PropTypes.func,
  placeholderIcon: PropTypes.string,
  source: PropTypes.string,
  title: PropTypes.node.isRequired,
};

LogoUploader.defaultProps = {
  accept: "image/png,image/jpeg,image/svg+xml,image/webp",
  placeholderIcon: "fa-building-o",
};
